import React, { useMemo } from 'react';
import { NavBar } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { t } from '../../i18n';
import { getNavBarContainerStyle } from '../../utils/deviceUtils';
import { popBack } from '../../utils/appRuntime';
import { useNativeLangSync } from '../../utils/langUtils';

interface DocumentViewerNativeProps {
    titleKey: string;
    documentType: 'terms' | 'privacy';
}

/**
 * 嵌入原生 WebView 时使用：返回走 swiftx://nativePopBack，不修改 {@link DocumentViewer}。
 */
const DocumentViewerNative: React.FC<DocumentViewerNativeProps> = ({ titleKey, documentType }) => {
    useNativeLangSync();
    const { i18n } = useTranslation();
    const navBarStyle = getNavBarContainerStyle();

    const htmlUrl = useMemo(() => {
        const language = i18n.language;
        let lang = 'en';

        if (language === 'zh' || language === 'zh-CN') {
            lang = 'zh';
        } else if (language === 'es' || language === 'es-ES') {
            lang = 'en';
        }

        const fileName = documentType === 'terms'
            ? `terms-of-use-${lang}.html`
            : `privacy-policy-${lang}.html`;

        return `/documents/${fileName}`;
    }, [i18n.language, documentType]);

    return (
        <div className="h-screen bg-white flex flex-col overflow-hidden">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={popBack}
                    style={{
                        ...navBarStyle.style,
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        background: '#fff',
                    }}
                >
                    {t(titleKey)}
                </NavBar>
            </div>

            <div className="flex-1 overflow-hidden" style={{ height: 0 }}>
                <iframe
                    src={htmlUrl}
                    className="w-full h-full border-0"
                    style={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                    }}
                    title={t(titleKey)}
                    sandbox="allow-same-origin allow-popups allow-top-navigation allow-scripts"
                />
            </div>
        </div>
    );
};

export default DocumentViewerNative;
